// Central glossary for hover tooltips across the app.
// Each entry: { title, desc, color }
const GREEN = "#00E599";
const GOLD = "#F0C000";
const CYAN = "#22D3EE";
const RED = "#FF3366";
const AMBER = "#F0A020";
const PURPLE = "#A78BFA";

export const GLOSSARY = {
  degenScore: {
    title: "Degen Score (0–100)",
    color: GREEN,
    desc: "A transparent health read on the coin: volume conviction, liquidity safety, buy pressure, survival and credibility. Higher = healthier setup. Rates the token, not who's buying.",
  },
  conviction: {
    title: "Conviction (0–100)",
    color: GOLD,
    desc: "Credibility-blind score — pure Volume + Survival + Buy Pressure. Catches real runners even when the token's website/socials look weak. 75+ = ANSEM-tier.",
  },
  techScore: {
    title: "Tech Score (0–100)",
    color: CYAN,
    desc: "How much a coin looks like a real product, not a pure meme: live website + real socials + utility keywords + survival. Tech plays tend to grind up instead of dumping.",
  },
  runnerScore: {
    title: "Runner Score (0–100)",
    color: GOLD,
    desc: "How closely a fresh, organic survivor matches the 'today's runner' pattern forming early — momentum + conviction + survival + clean structure. 72+ pings an alert.",
  },
  lpLocked: {
    title: "🔒 LP Locked / Burned",
    color: GREEN,
    desc: "Liquidity is locked or burned, so the dev can't pull it. One less rug vector — still DYOR on holders & authorities.",
  },
  lpUnlocked: {
    title: "🔓 LP Unlocked — BEWARE",
    color: RED,
    desc: "Liquidity isn't locked/burned; the dev can pull it at any time. Real demand can still rug fast. Take profits quick.",
  },
  organic: {
    title: "🌱 Organic",
    color: GREEN,
    desc: "Surfaced via trending / high-volume pools — no paid promotion. Real demand pushed it up.",
  },
  boosted: {
    title: "💸 Boosted",
    color: GOLD,
    desc: "Appeared via a paid DexScreener promotion. Someone paid to surface it — verify the demand is real.",
  },
  vamp: {
    title: "🧛 Vamp (copycat)",
    color: RED,
    desc: "A newer token copying an older, notable ticker. Verify you're on the real one before aping.",
  },
  og: {
    title: "OG (original ticker)",
    color: GREEN,
    desc: "The original, oldest notable token with this ticker. Copycats exist — this is the real one.",
  },
  scam: {
    title: "☠️ Community Scam Flag",
    color: RED,
    desc: "Flagged as a scam by 3+ AlphaApeing users. Auto-hidden from live feeds for everyone.",
  },
  trash: {
    title: "🗑️ Trash",
    color: RED,
    desc: "You marked this token as trash/scam. It's hidden from your Radar and Command Center.",
  },
  whale: {
    title: "🐋 Whale Magnet",
    color: CYAN,
    desc: "Whale-sized money is flowing in — big average trade size + buy pressure this hour. Free DexScreener signal, no wallet tracking needed.",
  },
  survivor: {
    title: "🛡️ Survivor",
    color: GREEN,
    desc: "This launch lasted: ≥10 min old, real liquidity, still trading, not dumped 90%. Filters out 5-minute rugs.",
  },
  quality: {
    title: "🏆 Quality",
    color: GOLD,
    desc: "The killer shortlist — launches that LASTED (Survivor) AND that whales are actively buying (Whale Magnet). As close to a real-runner list as we get for free.",
  },
  elite: {
    title: "💎 Elite",
    color: CYAN,
    desc: "Passes all 5 market-quality gates: deep liquidity, high volume, healthy market cap, right age window, and heavy transaction count.",
  },
  fastMover: {
    title: "🚀 Fast Mover",
    color: AMBER,
    desc: "A violent 1-hour price move (pump 🚀 or dump 🔻) on a low-cap. Pure price action — the token's lifecycle happening fast.",
  },
  momentum: {
    title: "Momentum (Running / Heating / Waking)",
    color: AMBER,
    desc: "Volume spiking above the hourly average with net buy pressure. 'Running' is hottest, 'Waking up' is early. The chart moving — not a wallet signal.",
  },
  cluster: {
    title: "🎯 Cluster Buy",
    color: PURPLE,
    desc: "Multiple different tracked wallets buying the SAME token within 6h — a convergence of proven people. Re-pings as more pile in.",
  },
  milly: {
    title: "💰 Milly's Call",
    color: GOLD,
    desc: "A tracked wallet throwing REAL size at a token — a whale buy or stacking buys crossing your SOL threshold in 6h. Cuts through the 0.1-SOL noise.",
  },
  millyRunner: {
    title: "🏃💰 Milly Runner Call",
    color: GOLD,
    desc: "The convergence super-signal: a coin that's RUNNING and getting a big Milly buy from a tracked wallet at the same time. The strongest tell.",
  },
  graduate: {
    title: "🎓 Fresh Graduate",
    color: CYAN,
    desc: "Just graduated the pump.fun bonding curve and is accelerating (volume surge + buy pressure) while still cheap — before it hits the mainstream Radar.",
  },
  theme: {
    title: "🔥 Theme / Meta",
    color: AMBER,
    desc: "A cluster of fresh tokens sharing a keyword in their name — a new meta forming. Hunt the cleanest survivor early.",
  },
  traction: {
    title: "📈 Traction",
    color: GREEN,
    desc: "On-chain community proxy — buy pressure + activity acceleration + sustained volume. Booming / Growing / Steady / Quiet. No social API.",
  },
  websiteLive: {
    title: "🌐 Website Live",
    color: GREEN,
    desc: "We fetched the site and it responded with real content — a working product page.",
  },
  websiteParked: {
    title: "🅿️ Parked Domain",
    color: AMBER,
    desc: "The domain is a 'for sale' / parking page — no real product behind it. Treat the tech claim with suspicion.",
  },
  websiteDead: {
    title: "💀 Dead Site",
    color: RED,
    desc: "The website didn't load (error / offline). A tech token with a dead site is a red flag.",
  },
};

export const glossaryColor = { GREEN, GOLD, CYAN, RED, AMBER, PURPLE };
